import React, { useMemo } from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import { App } from './components/app/App'
import { Toasts } from './components/toast/Toasts'

import { PrimeReactProvider } from 'primereact/api'
import 'primereact/resources/themes/lara-light-blue/theme.css'

const Wrapper = () => {
  /* THEME */
  const theme = useMemo(() => ({}), [])

  /* TEMPLATE */
  return (
    <PrimeReactProvider value={theme}>
      <Toasts />
      <App />
    </PrimeReactProvider>
  )
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <Wrapper />
  </React.StrictMode>
)
